export default {
  totality: 'La totalité',
  specificNumber: 'Un nombre précis',
  numberOfBoxesWanted: 'Combien de cartons souhaitez-vous que les déménageurs vous fournissent ?',
  specificNumberOfBox: 'Précisez le nombre de cartons que vous souhaitez :',
};
